// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDIsDJ_MEjkyA_CQ_DzkyopAvCAVJEi124",
  authDomain: "aralplus-b12d6.firebaseapp.com",
  projectId: "aralplus-b12d6",
  storageBucket: "aralplus-b12d6.appspot.com",
  messagingSenderId: "736518609283",
  appId: "1:736518609283:web:408064e88813f86ff87eb6",
  measurementId: "G-3Z5EJ9DKS7",
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
export const firestore = firebase.firestore;
export const db = app.firestore();
export const auth = app.auth();
export const fb = firebase;
export default app;
